import { useTranslation } from "react-i18next";
import { SubscriptionChangeMode } from "../SubscriptionChangeConfirmationModalV2.interfaces";
import { MODAL_STYLES } from "../SubscriptionChangeConfirmationModalV2.helpers";

interface TotalDueSectionProps {
  mode: SubscriptionChangeMode;
  totalDue: number;
  compact?: boolean;
}

export default function TotalDueSection({
  mode,
  totalDue,
  compact,
}: TotalDueSectionProps) {
  const { t } = useTranslation("pages");
  return (
    <div
      className={`flex justify-between items-center px-5 rounded-lg border ${
        compact ? "py-3 mb-3" : "py-5 mb-4"
      }`}
      style={{
        background: MODAL_STYLES.totalDue.background,
        borderColor: MODAL_STYLES.totalDue.borderColor,
      }}
    >
      <span
        className="text-sm font-semibold"
        style={{ color: MODAL_STYLES.totalDue.color }}
      >
        {t("profilePage.billing.changeConfirm.totalDueToday")}
      </span>
      <span
        className="text-2xl font-bold"
        style={{ color: MODAL_STYLES.totalDue.color }}
      >
        ${mode === "downgrade" ? "0.00" : totalDue.toFixed(2)}
      </span>
    </div>
  );
}
